/* permission/types */
import * as t from "io-ts";

export const PermissionCodec = t.type({
  data: t.any
});

export const AccessCodec = t.type({
  R: t.boolean,
  C: t.boolean,
  D: t.boolean,
  U: t.boolean
})

export type Permission = t.TypeOf<typeof PermissionCodec>;
export type Access = t.TypeOf<typeof AccessCodec>;

export enum PermissionActionTypes {
  FETCH = "@@permission/FETCH",
  FETCH_SUCCESS = "@@permission/FETCH_SUCCESS",
  FETCH_ERROR = "@@permission/FETCH_ERROR"
}

export interface PermissionState {
  readonly loading: boolean;
  readonly data: Permission | null;
  readonly errors?: string;
}
